export function Gauge(props: { progress: number }) {
  const maxProgress = props.progress < 1 ? props.progress : 1;
  let pointerAngle = -90;
  pointerAngle += 180 * maxProgress;
  const fillAngle = 180 * maxProgress;
  let fillColor = "#20C460";
  if (maxProgress > 0.75) fillColor = "#E9B310";
  if (maxProgress > 0.9) fillColor = "#DA2727";
  return (
    <div className="gauge">
      <div className="gauge__meter">
        <div className="gauge__inner" />
        <div
          className="gauge__fill"
          style={{ transform: `rotate(${fillAngle}deg)`, backgroundColor: fillColor }}
        />
      </div>
      <div className="gauge__pointer" style={{ transform: `rotate(${pointerAngle}deg)` }} />
      <div className="gauge__knob" />
    </div>
  );
}

export default Gauge;
